export default __webpack_public_path__ + "static/media/pic1.bcb16976.jpg";